import { useAgentEditorStore } from '@/state/root';
import theme from '@/theme';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';

const Text = styled.text`
    display: inline-flex;

    border-radius: 4px;
    padding: 0px 4px;
    background: rgba(170, 249, 178, 0.4);
    color: ${theme.colors.success[600]};
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.15px;
`;

export const New = observer(() => {
    const agentEditorStore = useAgentEditorStore();

    if (agentEditorStore.isAgentEdit) return <Text>NEW</Text>;
});
